<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入搜索内容"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-select
        class="mr10"
        clearable
        v-model="auditStatus"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in auditStatusOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column header-align="center" prop="position_name" label="职位">
      </el-table-column>
      <el-table-column
        prop="publish_name"
        align="center"
        label="发布者"
      ></el-table-column>
      <el-table-column align="center" label="发布时间" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.publish_time, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column label="上架状态" align="center">
        <template #default="scope">
          <el-link
            :underline="false"
            href="javascript:void(0);"
            type="danger"
            v-if="scope.row.status === 0"
            >下架</el-link
          >
          <el-link
            :underline="false"
            href="javascript:void(0);"
            type="success"
            v-if="scope.row.status === 1"
            >上架</el-link
          >
        </template>
      </el-table-column>

      <el-table-column label="职位详情" align="center">
        <template #default="scope">
          <el-button size="mini" type="text" @click="getInfo(scope.row)"
            >职位详情</el-button
          >
        </template>
      </el-table-column>

      <el-table-column label="操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="mini"
            v-if="scope.row.audit_status === 1"
            @click="handleEdit(scope.row, 3)"
            >禁止展示</el-button
          >
          <el-button
            type="warning"
            size="mini"
            v-if="scope.row.audit_status === 3"
            @click="handleEdit(scope.row, 1)"
            >恢复展示</el-button
          >
          <el-button type="danger" size="mini" @click="delData(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <el-dialog
      title="详情"
      v-model="dialog"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="event_wrap">
        <el-form size="mini" label-position="top" inline>
          <div>
            <el-form-item>
              {{ itemData.position_name }}
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>发布者：</span> {{ itemData.publish_name }}
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>发布时间：</span>
              {{ $utils.formatDate(itemData.publish_time, "yyyy-MM-dd hh:mm") }}
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>工作地址：</span>
              {{ itemData.address }}
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>工作年限：</span>
              {{ itemData.year_of_work || "不限" }}
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>学历要求：</span>
              {{ itemData.education }}
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>薪资范围：</span>
              {{ itemData.salary_range }}
            </el-form-item>
          </div>
          <div>
            <el-form-item label="职位描述：">
              {{ itemData.remark }}
            </el-form-item>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialog = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      itemData: {},
      dialog: false,
      auditStatus:'',
      auditStatusOption: [
        { label: "全部", value: -1 },
        { label: "正常展示", value: 1 },
        { label: "被禁止展示", value: 3 },
      ],
    };
  },
  methods: {
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        name: this.searchName,
        auditStatus:this.auditStatus,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.position.list.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    handleEdit(data, status) {
      if (!this.loading) {
        const text =
          status === 1 ? "是否确认恢复？" : "是否确认禁止展示？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const params = {
                id: data.id,
                auditStatus: status,
              };
              const res = await this.$api.position.list.setData(params);
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData(this.data.current);
                this.$message.success("操作成功！");
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
    async getInfo(data) {
      try {
        this.$loading.start();
        const res = await this.$api.position.review.getInfo({
          id: data.id,
        });
        this.$loading.done();
        if (res.code === 10200) {
          this.itemData = res.data;
          this.dialog = true;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error)
        this.$loading.done();
      }
    },
    // 删除
    delData(data) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: data.id,
            };
            const res = await this.$api.position.list.delData(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          } catch (error) {
            this.loading = false;
            this.$loading.done();
          }
        })
        .catch(() => {});
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.cover {
  width: 160px;
  height: 90px;
  display: inline-block;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  h2 {
    font-size: 1rem;
    font-weight: 500;
    padding: 5px 0;
    color: $--color-primary;
  }

  .atlas {
    display: flex;
    flex-wrap: wrap;

    & > div {
      width: 160px;
      height: 90px;
      margin-bottom: 10px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .certification {
    display: inline-block;
  }

  .el-form-item {
    margin-bottom: 0;
    .el-form-item__label {
      padding: 0;
    }
  }
}
</style>